export default (width = 34, height = 34, color = '#979797') => `
<svg width="${width}" height="${height}" viewBox = "0 0 34 34"  fill="none" xmlns="http://www.w3.org/2000/svg">
    <path stroke="${color}" stroke-width="2" d="M3.833 3.833h10.75v10.75H3.833z"/>
    <path stroke="${color}" stroke-width="2" stroke-dasharray="4 2" d="M3.833 19.416h10.75v10.75H3.833zM19.417 3.833h10.75v10.75h-10.75z"/>
    <path stroke="${color}" stroke-width="2" d="M19.417 19.416h10.75v10.75h-10.75z"/>
</svg>
`